import { useState } from 'react'

import { useAuth } from '../auth'
import { flush, pullSnapshot } from '../lib/sync'
import { setUIMode } from './isMobile'
import { Bar } from './TaskCard'
import { useSync } from './useLocal'

const ROLE_LABEL: Record<string, string> = {
  admin: 'Администратор',
  manager: 'Менеджер',
  specialist: 'Специалист',
}

export default function Profile({ onBack, onLogout, onToast }: {
  onBack: () => void
  onLogout: () => void | Promise<void>
  onToast: (text: string) => void
}) {
  const { user, permissions } = useAuth()
  const sync = useSync()
  const [confirming, setConfirming] = useState(false)
  const [busy, setBusy] = useState(false)

  const syncNow = async () => {
    setBusy(true)
    await flush()
    await pullSnapshot()
    setBusy(false)
    onToast('Данные обновлены')
  }

  return (
    <>
      <Bar title="Профиль" onBack={onBack} />

      <div className="m-block" style={{ marginTop: 16 }}>
        <div className="m-card">
          <div style={{ fontSize: 17, fontWeight: 700 }}>{user?.full_name}</div>
          <div className="m-sub" style={{ marginTop: 4 }}>
            {permissions?.group_name ?? ROLE_LABEL[user?.role ?? ''] ?? user?.role}
          </div>
          {user?.email && <div className="m-sub" style={{ marginTop: 2 }}>{user.email}</div>}
        </div>
      </div>

      <div className="m-block">
        <div className="m-block-title">Синхронизация</div>
        <div className="m-card">
          <div className="m-kv">
            <span className="m-kv-k">Связь</span>
            <span className="m-kv-v" style={{ color: sync.online ? '#10664d' : '#b45309' }}>
              {sync.online ? 'есть' : 'нет'}
            </span>
          </div>
          <div className="m-kv">
            <span className="m-kv-k">Не отправлено</span>
            <span className="m-kv-v">{sync.pending}</span>
          </div>
          <div className="m-kv">
            <span className="m-kv-k">Данные от</span>
            <span className="m-kv-v">
              {sync.syncedAt
                ? new Date(sync.syncedAt).toLocaleString('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                  })
                : 'ещё не загружались'}
            </span>
          </div>
          {sync.lastError && (
            <div className="m-kv">
              <span className="m-kv-k">Ошибка</span>
              <span className="m-kv-v" style={{ color: '#b91c1c' }}>{sync.lastError}</span>
            </div>
          )}
        </div>
        <button
          className="m-btn m-btn-navy"
          style={{ width: '100%', marginTop: 10 }}
          disabled={busy || !sync.online}
          onClick={() => void syncNow()}
        >
          {busy ? 'Обновляем…' : 'Обновить сейчас'}
        </button>
      </div>

      <div className="m-block">
        <div className="m-block-title">Вид</div>
        <button
          className="m-btn m-btn-ghost"
          style={{ width: '100%' }}
          onClick={() => {
            setUIMode('desktop')
            window.location.reload()
          }}
        >
          Полная версия
        </button>
      </div>

      <div className="m-block">
        {sync.pending > 0 && (
          <div className="m-card" style={{ background: '#fef3c7', borderColor: '#f0c98a', color: '#a15c07', fontSize: 14, marginBottom: 10 }}>
            Не отправлено операций: {sync.pending}. При выходе они пропадут.
          </div>
        )}
        {confirming ? (
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="m-btn m-btn-ghost" style={{ flex: 1 }} onClick={() => setConfirming(false)}>
              Отмена
            </button>
            <button className="m-btn m-btn-stop" style={{ flex: 1 }} onClick={() => void onLogout()}>
              Выйти
            </button>
          </div>
        ) : (
          <button className="m-btn m-btn-ghost" style={{ width: '100%', color: '#b91c1c' }} onClick={() => setConfirming(true)}>
            Выйти из программы
          </button>
        )}
      </div>

      <div style={{ height: 24 }} />
    </>
  )
}
